<!-- Header -->
<header
  id="header"
  #headerc
  data-transparent="false"
  data-fullwidth="true"
  class="submenu-light"
>
  <!--  -->
  <!--   -->
  <div class="header-inner">
    <div class="container">
      <!--Logo-->
      <div id="logo">
        <a routerLink="/">
          <img src="assets/images/2023/logo.png" class="mt-1 logo-default d-none d-xl-block" />
          <img src="assets/images/2023/logo-mobile.png" class="logo-default  d-xl-none" />
          <!-- <img src="assets/images/2023/logo.png" class="logo-dark d-lg-none d-xl-block" /> -->
        </a>
      </div>
      <!--End: Logo-->
      <!-- Search -->
      <theme-POLO-search *ngIf="searchVisible"></theme-POLO-search>
      <!-- end: search -->
      <!--Header Extras-->
      <!-- <div class="header-extras">
        <ul>
          <li>
            <a id="btn-search" href="#" (click)="toggleSearch()">
              <i class="icon-search"></i
            ></a>
          </li>
          <li>
                      <div class="p-dropdown"> <a href="#"><i class="icon-globe"></i><span>EN</span></a>
                          <ul class="p-dropdown-content">
                              <li><a href="#">French</a></li>
                              <li><a href="#">Spanish</a></li>
                              <li><a href="#">English</a></li>
                          </ul>
                      </div>
                  </li>
        </ul>
      </div> -->
      <!--end: Header Extras-->
      <!--Navigation Resposnive Trigger-->
      <div id="mainMenu-trigger">
        <button class="lines-button x"><span class="lines"></span></button>
      </div>
      <!--end: Navigation Resposnive Trigger-->
      <!--Navigation-->
      <div id="mainMenu">
        <div class="container">
          <nav>
            <ul>
              <!-- <li><a href="#presentation">Présentation</a></li> -->
              <li><a routerLink="/forum" class="forumdclic" (click)="closeMenu()">Forum <span class="position-relative"><img class="star-image" src="assets/images/2024/forum/logo2024.png"/></span></a></li>
              <li><a routerLink="/" routerLinkActive="active" routerLinkActiveOptions="{exact:true}" (click)="closeMenu()">Accueil</a></li>
              <!-- <li><a routerLink="/decouvrir" routerLinkActive="active color-orange">Découvrir</a></li> -->
              <li><a routerLink="/jeunes" routerLinkActive="active color-blue" (click)="closeMenu()">Jeunes</a></li>
              <li><a routerLink="/proprietaires" routerLinkActive="active color-green" (click)="closeMenu()">Bailleurs</a></li>
              <!-- <li><a routerLink="/actualite">Actus</a></li> -->
              <li><a routerLink="/contact" routerLinkActive="active color-orange" (click)="closeMenu()">Contact</a></li>
              <li><a routerLink="/faq" routerLinkActive="active color-orange" (click)="closeMenu()">FAQ</a></li>
              <li><a href="https://cllaj-martinique.fr/contact_temp/contact.html" (click)="closeMenu()">Ma rentrée Me loger</a></li>
              <li><a routerLink="/connexion" *ngIf="!this.authenticationService.currentUserValue" (click)="closeMenu()">Se connecter</a></li>
              <li><a routerLink="/jeunes/inscription" [queryParams]="{mode: 'informe'}" *ngIf="!currentUser" (click)="closeMenu()">En savoir +</a></li>
              <li *ngIf="currentUser" class="dropdown" [class.hover-active]="dropdownOpen && isMobile">
                <span class="dropdown-arrow" (click)="toggleDropdown($event)"></span>
                <a routerLink="/jeunes/mon-espace" (click)="toggleDropdown($event)">{{ currentUser.email.substring(0,12) }}{{ currentUser.email?.length > 12 ? "..." : "" }}</a>
                <ul class="dropdown-menu">
                  <li *ngIf="currentUser && (globalHelper.hasRoles(['JEUNE']) || globalHelper.currentUser?.role == 'visiteurJ' || globalHelper.currentUser?.role == 'jeune')"><a routerLink="/jeunes/mon-espace" (click)="closeMenu()">Mon Espace Jeune</a></li>
                  <li *ngIf="currentUser && (globalHelper.hasRoles(['PROPRIETAIRE']) || globalHelper.currentUser?.role == 'visiteurP' || globalHelper.currentUser?.role == 'proprio')"><a routerLink="/proprietaires/mon-espace" (click)="closeMenu()">Mon Espace Proprietaire</a></li>
                  <li *ngIf="currentUser && globalHelper.hasRoles(['ADMIN_'])"><a routerLink="/dashboard" (click)="closeMenu()">Tableau de bord</a></li>
                  <li *ngIf="currentUser && globalHelper.hasRoles(['ADMIN']) || globalHelper.currentUser?.role?.indexOf('admin') > -1"><a routerLink="/admin/routageDossier" (click)="closeMenu()">Administration</a></li>
                  <li><a routerLink="/auth/logout" *ngIf="currentUser" (click)="closeMenu()">Se déconnecter</a></li>
                </ul>
              </li>

              <!-- <li class="dropdown right">
                <span class="dropdown-arrow"></span
                ><a routerLink="/i"
                  >{{ currentUser ? currentUser.username + " " : ""
                  }}<i class="fa fa-user"></i
                ></a>
                <ul class="dropdown-menu" style="">
                  <li>
                    <a [routerLink]="['/jeunes/mon-espace']" *ngIf="!currentUser"
                      >Connexion</a
                    >
                  </li>
                  <li>
                    <a
                      [routerLink]="['/dashboard']"
                      *ngIf="currentUser && globalHelper.hasRoles('ADMIN')"
                      >Dashboard</a
                    >
                  </li>
                  <li>
                    <a
                      [routerLink]="['/auth/logout']"
                      *ngIf="currentUser"
                      (click)="authenticationService.logout()"
                      >Déconnexion</a
                    >
                  </li>
                </ul>
              </li> -->
            </ul>
          </nav>
        </div>
      </div>
      <!--end: Navigation-->
    </div>
  </div>
</header>
<!-- end: Header -->
